// Option A: named export
export const moduleaccuracy = {
  Helmet: {
    result_true: 100,
    ai_result_true: 100.0,
  },
  Vest: { 
    result_true: 0,
    ai_result_true: 0,
  },
  MMHE: {
    result_true: 0,
    ai_result_true: 0,
  },
  "Emergency Exit": {
    result_true: 0,
    ai_result_true: 0,
  },
  "No Go": {
    result_true: 0,
    ai_result_true: 0,
  },
}
  

export const dataAlerts = {
  totalRecords: 1,
  acceptedRecords: 1,
  rejectedRecords: 0,
  acceptedAitechqaRecords: 1,
  rejectedAitechqaRecords: 0,
  totalAcknowledged: 0,
  totalUnacknowledged: 1,
  totalPages: 1,
  alerts: [
    {
      operationSafetyId: 2150603,
      vioSeverity: "medium plus",
      module: "Helmet",
      violation: "Helmet",
      violationArea: "Indoor",
      cameraName: "CCTV Gallery",
      date: "2025-06-30",
      time: "12:26 AM",
      shift: "Shift B",
      image:
        "https://unilever-alert-images.s3.us-east-2.amazonaws.com/E:/uniliver/alert_saves/helmet_violations/annotated/daily/2025-06-30/ICF-AO9-CCT-1-8-9-3_30-06-2025_12-26-49AM.jpg",
      unannotatedImage:
        "https://unilever-alert-images.s3.us-east-2.amazonaws.com/E:/uniliver/alert_saves/helmet_violations/unannotated/daily/2025-06-30/ICF-AO9-CCT-1-8-9-3_30-06-2025_12-26-49AM.jpg",
      cameraId: "ICF-AO9-CCT-1-8-9-3",
      area: "AO‑9",
      areaOwner: "Waqar Ahmad",
      subarea: "Galleries",
      acknowledged: false
    }
  ]
};


export const getOperationIDStaticData = {
  data: {
    ids: {
      accepted: [
        2173990,
        2173999,
        2174020,
        2174037,
        2176091,
        2176148,
        2176321,
        2177642,
        2177707,
        2177789,
        2177870,
        2177916,
        2178753
      ],
      rejected: []
    }
  },
  status: 200,
  statusText: "OK",
}
